import { render, staticRenderFns } from "./studentPage.vue?vue&type=template&id=2f96bb1e&scoped=true"
import script from "./studentPage.vue?vue&type=script&lang=js"
export * from "./studentPage.vue?vue&type=script&lang=js"
import style0 from "./studentPage.vue?vue&type=style&index=0&id=2f96bb1e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f96bb1e",
  null
  
)

export default component.exports